<template>
  <v-container fluid :class="{ 'theme--dark': isDarkMode }">
    <!-- Header -->
    <v-row>
      <v-col cols="12" class="pa-0">
        <v-app-bar dense elevation="1" style="background-color: rgb(229 57 53);">
          <v-toolbar-title class="white--text">Canal Inbi</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="isDarkMode = !isDarkMode"
            class="white--text"
          >
            <v-icon size="20">{{ isDarkMode ? 'mdi-weather-sunny' : 'mdi-weather-night' }}</v-icon>
          </v-btn>
          <v-btn
            icon
            :to="{ name: 'GruposAlumnos' }"
            class="white--text"
          >
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </v-app-bar>
      </v-col>
    </v-row>

    <!-- Resto del componente permanece igual -->
    <v-row>
      <!-- Área del video -->
      <v-col cols="12" md="8" class="pt-0 pl-0 pr-0">
        <v-card flat :class="{ 'dark-card': isDarkMode }">
          <iframe
            v-if="currentVideo"
            :src="currentVideo.url + '?rel=0' "
            frameborder="0"
            class="pa-2"
            allowfullscreen
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            style="width: 100%; height: 500px;"
          ></iframe>

          <v-img
            v-else
            src="@/assets/backgrounds/learn.png"
            contain
            aspect-ratio="2"
            class="pa-2"
          />
        </v-card>
      </v-col>

      <!-- Lista de videos -->
      <v-col cols="12" md="4" class="pt-0 pl-0 pr-0">
        <v-card flat :height="tamanioPantalla" :class="{ 'dark-card': isDarkMode }" class="overflow-y-auto">
          <v-card-title class="justify-center white--text py-3" style="background-color: rgb(229 57 53);">
            Lista de Videos
          </v-card-title>

          <v-list :class="{ 'dark-list': isDarkMode }">
            <v-list-item-group>
              <v-list-item
                v-for="video in videos"
                :key="video.id"
                @click="reproducirVideo(video)"
                class="mb-2"
                :class="{ 'dark-item': isDarkMode }"
              >
                <v-list-item-content>
                  <v-list-item-title class="video-title" :class="{ 'white--text': isDarkMode }">
                    {{ video.titulo }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="video-description" :class="{ 'grey--text': isDarkMode }">
                    {{ video.descripcion }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-avatar size="80" class="mr-4" style="border-radius: 7px;">
                  <img
                    :src="`https://img.youtube.com/vi/${obtenerVideoID(video.url)}/0.jpg`"
                    style="width: 80px; height: 60px; object-fit: cover;"
                  >
                </v-list-item-avatar>
                <v-list-item-action>
                  <v-btn
                    icon
                    color="error"
                    class="mr-2"
                  >
                    <v-icon>mdi-play-circle</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>
    </v-row>

    <Alerta v-if="respuestaAlerta" :parametros="parametros"/>
    <Loader v-if="cargar" :loader="loader"/>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import Alerta from '@/components/alertas/Alerta.vue'
import Loader from '@/components/alertas/Loader.vue'
import validarErrores from '@/mixins/validarErrores.js'

export default {
  name: "youtube-course-viewer",

  mixins: [validarErrores],

  components: {
    Alerta,
    Loader
  },

  data: () => ({
    videos: [],
    currentVideo: null,
    scrollInvoked: 0,
    parametros: {
      dialogError: false,
      mensaje: '',
      color: ''
    },
    respuestaAlerta: false,
    loader: true,
    cargar: false,
    isDarkMode: false
  }),

  computed: {
    ...mapGetters('login', ['getUsuarioLMS']),

    tamanioPantalla() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return (this.$vuetify.breakpoint.height / 2) + 80
        case 'sm': return (this.$vuetify.breakpoint.height / 2) - 150
        case 'md': return this.$vuetify.breakpoint.height - 120
        case 'lg': return this.$vuetify.breakpoint.height - 120
        case 'xl': return this.$vuetify.breakpoint.height - 120
        default: return this.$vuetify.breakpoint.height - 120
      }
    }
  },

  created() {
    this.cargarVideos()
    // Cargar preferencia de tema del localStorage si existe
    const savedTheme = localStorage.getItem('darkMode')
    if (savedTheme !== null) {
      this.isDarkMode = JSON.parse(savedTheme)
      this.updateTheme()
    }
  },

  methods: {
    toggleTheme() {
      this.isDarkMode = !this.isDarkMode
      localStorage.setItem('darkMode', JSON.stringify(this.isDarkMode))
      this.updateTheme()
    },

    updateTheme() {
      // Actualizar el tema de Vuetify
      this.$vuetify.theme.dark = this.isDarkMode
    },

    obtenerVideoID(url) {
        const partes = url.split('/');
        const videoIDConParams = partes[partes.length - 1];
        return videoIDConParams.split('?')[0];
      },

    async cargarVideos() {
      try {
        this.cargar = true;
        const response = await this.$http.get('videos');


        if (response.body && Array.isArray(response.body)) {
          this.videos = response.body;
          if (this.videos.length > 0 && !this.currentVideo) {
            this.currentVideo = this.videos[0];
          }
        } else {
          console.error('Formato de respuesta inesperado:', response.body);
        }
      } catch (error) {
        console.error('Error al cargar videos:', error);
        this.validarError(error);
      } finally {
        this.cargar = false;
      }
    },


    async reproducirVideo(video) {
      try {
        this.currentVideo = video;
        if (!this.getUsuarioLMS || !this.getUsuarioLMS.id) {
          console.warn('No hay usuario autenticado');
          return;
        }

        const payload = {
          id_video: video.id,
          iderp_usuario: this.getUsuarioLMS.iderp
        };

        const response = await this.$http.post('video-eventos', payload);
      } catch (error) {
        console.error('Error completo:', error);
        // Opcionalmente mostrar un mensaje al usuario
        this.parametros = {
          dialogError: true,
          mensaje: 'Error al registrar la visualización del video',
          color: 'error'
        };
        this.respuestaAlerta = true;
      }
    },

    onScroll() {
      this.scrollInvoked++
    }
  }
}
</script>


<style scoped>
.colorCurso {
  color: #006093;
}

.video-title {
  font-weight: 500;
  margin-bottom: 4px;
}

.video-description {
  color: rgba(0, 0, 0, 0.6);
  margin-bottom: 8px;
}

.v-card::-webkit-scrollbar {
  -webkit-appearance: none !important;
  width: 8px !important;
}

.v-card::-webkit-scrollbar-thumb {
  background-color: #BABCBF;
  border-radius: 20px;
  border: 1px solid #ededed;
}

.v-list-item {
  border-radius: 4px;
  margin: 0 8px;
}

.v-list-item:hover {
  background-color: #f5f5f5;
}

.v-list-item-title {
  line-height: 1.4;
  margin-bottom: 4px;
}

.v-list-item-subtitle {
  white-space: normal;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Estilos para el modo oscuro */
.theme--dark {
  background-color: #121212;
}

.dark-card {
  background-color: #1E1E1E !important;
  color: white !important;
}

.dark-list {
  background-color: #1E1E1E !important;
}

.dark-item {
  background-color: #1E1E1E !important;
}

.dark-item:hover {
  background-color: #2C2C2C !important;
}

/* Ajustes para la barra superior */
.v-app-bar .v-btn {
  opacity: 1 !important;
}

.v-app-bar .v-icon {
  color: white !important;
}
</style>
